import angular from 'angular';

angular.module('cloudX').directive('uiSelectContainer', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'C',
      require: ['uiSelect', '?^form'],
      link: function(scope, element, attrs, ctrl) {
        var $select = ctrl[0];
        var form = ctrl[1];
        if (!form) return;

        $timeout(function() {
          ///Open ui select on focus
          if (!$select.open) $select.toggle();
          ///Submit on select
          $select.onSelectCallback = function() {
            form.$submit();
          };
        });
      },
    };
  },
]);
